import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Divider = styled(Box)`
  width: 100%;
`;

export const Title = styled(Typography)`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: ${({ theme }) => theme.palette.common.black};
`;
